import React from "react";
import './styles.scss';

export default ({className}) => (
  <div className={['caret', className].join(' ')}>
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 5.46392e-08L-5.34503e-08 1.2228L5 6L10 1.2228L8.75 3.82475e-07L5 3.6L1.25 5.46392e-08Z" />
    </svg>
  </div>
)
